import React, { useState } from 'react';
import classNames from 'classnames';

/* Validation */
import { Formik } from 'formik';
import validationSchema from './formConfig';

/* Shared Imports */
import CustomError from './CustomError';

/* Gjensidige Core 20 Imports */
import utils from '@gjensidige/core-utilities-css';

/* Gjensidige Core 30 Imports */
import { Alert } from '@gjensidige/core-components/lib/alerts/default';
import { Container, Row, Col } from '@gjensidige/nci-core-grid';
import { Input } from '@gjensidige/core-components/lib/forms/input';
import { Title } from '@gjensidige/nci-core-typography';
import { InputGroupSimple } from '@gjensidige/core-components/lib/forms/input-group-simple';
import { Checkbox } from '@gjensidige/core-components/lib/forms/checkbox';

/* API */
import axios from 'axios';
import { Endpoints } from '@internal/common';
import {Button} from "@gjensidige/core-components/lib/button";

const SecurityPackageOfferDIByggeri = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    cvrNumber: '',
    name: '',
    phoneNumber: '',
    email: '',
    contactSecurityPackageConsent: false,
    memberType: '',
    contactOffersConsent: false
  });
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState(false);

  const sendFormData = () => {
    setApiError(false);
    axios
      .post(Endpoints.SecurityPackageDIByggeri, formData)
      .then(() => setSubmitted(true))
      .catch(() => setApiError(true));
  };

  return (
    <Container className={utils['mt-2']}>
      {submitted ? (
        <Row className={utils['justify-content-center']}>
          <Alert
            alertType="success"
            showIcon
            title="Tak for din henvendelse​"
            text="Vores samarbejdspartner kontakter dig med et tilbud på Sikringspakken i løbet af et par hverdage. ​
          Har du bedt om et uforpligtende tilbud på dine forsikringer, kontakter vi dig hurtigst muligt.​​​"
            className={utils['mb-3']}
          />
        </Row>
      ) : (
        <Formik
          enableReinitialize
          initialValues={{
            companyName: formData.companyName,
            cvrNumber: formData.cvrNumber,
            name: formData.name,
            phoneNumber: formData.phoneNumber,
            email: formData.email,
            contactSecurityPackageConsent:
              formData.contactSecurityPackageConsent,
            memberType: formData.memberType,
            contactOfferConsent: formData.contactOffersConsent
          }}
          validationSchema={validationSchema(formData)}
          onSubmit={() => {
            sendFormData();
          }}
        >
          {(props) => {
            const {
              handleSubmit,
              handleBlur,
              setFieldValue,
              touched,
              errors
            } = props;
            return (
              <form onSubmit={handleSubmit} className={utils['pb-3']}>
                <Row
                  className={classNames(
                    utils['mb-3'],
                    utils['justify-content-center']
                  )}
                >
                  <Col lg={6}>
                    <Title tag="h4">Bestil tilbud</Title>
                  </Col>
                </Row>
                <Row className={utils['justify-content-center']}>
                  <Col lg={6}>
                    <Input
                      id="company-name"
                      labelText="Virksomhedens navn *"
                      name="companyName"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('companyName', event.target.value);
                        setFormData({
                          ...formData,
                          companyName: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.companyName && errors.companyName)}
                      errorText={errors.companyName}
                      value={formData.companyName}
                    />
                    <Input
                      id="cvr-number"
                      labelText="CVR-nummer"
                      name="cvrNumber"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('cvrNumber', event.target.value);
                        setFormData({
                          ...formData,
                          cvrNumber: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.cvrNumber && errors.cvrNumber)}
                      errorText={errors.cvrNumber}
                      value={formData.cvrNumber}
                    />
                    <Input
                      id="name"
                      labelText="Navn"
                      name="name"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('name', event.target.value);
                        setFormData({ ...formData, name: event.target.value });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.name && errors.name)}
                      errorText={errors.name}
                      value={formData.name}
                    />
                    <Input
                      id="phone-number"
                      labelText="Dit telefonnummer"
                      name="phoneNumber"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('phoneNumber', event.target.value);
                        setFormData({
                          ...formData,
                          phoneNumber: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.phoneNumber && errors.phoneNumber)}
                      errorText={errors.phoneNumber}
                      value={formData.phoneNumber}
                    />
                    <Input
                      id="email"
                      labelText="Din mail *"
                      name="email"
                      className={utils['pb-2']}
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue('email', event.target.value);
                        setFormData({
                          ...formData,
                          email: event.target.value
                        });
                      }}
                      onBlur={handleBlur}
                      invalid={!!(touched.email && errors.email)}
                      errorText={errors.email}
                      value={formData.email}
                    />
                    <Checkbox
                      id="contactSecurityPackageConsent-id"
                      label="Ja, jeg vil gerne kontaktes med et tilbud på Sikringspakken? *"
                      name="contactSecurityPackageConsent"
                      type="checkbox"
                      value="contactSecurityPackageConsent"
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue(
                          'contactSecurityPackageConsent',
                          event.target.checked
                        );
                        setFormData({
                          ...formData,
                          contactSecurityPackageConsent: event.target.checked
                        });
                      }}
                      onBlur={handleBlur}
                      className={utils['pb-2']}
                      topAlignInput
                      checked={formData.contactSecurityPackageConsent}
                    />
                    {touched.contactSecurityPackageConsent &&
                    errors.contactSecurityPackageConsent ? (
                      <CustomError
                        errorText={errors.contactSecurityPackageConsent}
                      />
                    ) : (
                      ''
                    )}
                    <InputGroupSimple
                      vertical
                      header="Vælg det, der gælder for dig"
                      id="memberType"
                      className={utils['pb-2']}
                      name="memberType"
                      centered={false}
                      onChange={(event) => {
                        setFormData({
                          ...formData,
                          memberType: event.target.value
                        });
                        setFieldValue('memberType', event.target.value);
                      }}
                      options={[
                        {
                          label: 'Jeg er medlem af DI Byggeri',
                          value: 'Jeg er medlem af DI Byggeri'
                        },
                        {
                          label:
                            'Jeg er medlem af DI Byggeri og forsikret hos Gjensidige',
                          value:
                            'Jeg er medlem af DI Byggeri og forsikret hos Gjensidige'
                        }
                      ]}
                      type="radio"
                      value={formData.memberType}
                      onBlur={handleBlur}
                      invalid={!!(touched.memberType && errors.memberType)}
                      errorText={errors.memberType}
                    />
                    <Checkbox
                      id="contactOffersConsent-id"
                      label="Ja, jeg vil gerne kontaktes med et tilbud på mine forsikringer"
                      name="contactOffersConsent"
                      type="checkbox"
                      value="contactOffersConsent"
                      onChange={(
                        event: React.ChangeEvent<HTMLInputElement>
                      ) => {
                        setFieldValue(
                          'contactOffersConsent',
                          event.target.checked
                        );
                        setFormData({
                          ...formData,
                          contactOffersConsent: event.target.checked
                        });
                      }}
                      onBlur={handleBlur}
                      className={utils['pb-2']}
                      topAlignInput
                      checked={formData.contactOffersConsent}
                    />
                    <Button variant={'primary'} type="submit" flexible>
                      Bestil tilbud
                    </Button>
                  </Col>
                </Row>
              </form>
            );
          }}
        </Formik>
      )}
      {apiError && (
        <Row className={utils['justify-content-center']}>
          <Alert
            alertType="error"
            showIcon
            text="Der skete en fejl ved indsendelse. Prøv venligst igen senere"
            title="Der skete en fejl."
            className={utils['mb-3']}
          />
        </Row>
      )}
    </Container>
  );
};

export default SecurityPackageOfferDIByggeri;
